module.exports = "pegasus/assets/social_share_library_block.png";